import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { StreamableFile } from "@nestjs/common";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { ClassFilterType } from "@common/types/class";
import { AccountingReportCycle } from "../constants";
import { CashFlowReportDto } from "../dto/reports/cash-flow-tab-report-response.dto";
import { ProfitLossTopTransactionsDto } from "../dto/reports/reporting-tab-profit-loss-response.dto";

const c = initContract();

const getCashFlowReportQuery = z.object({
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    entityIds: z.array(z.coerce.number()),
    accountIds: z.array(z.coerce.number()).optional(),
    cycle: z.nativeEnum(AccountingReportCycle),
    category: z.array(z.string()).optional(),
    classes: z.array(z.string()).optional(),
    classFilterType: z.nativeEnum(ClassFilterType).optional(),
});

const getTopTransactionsQuery = z.object({
    startDate: z.string(),
    endDate: z.string(),
    entityIds: z.array(z.coerce.number()),
    accountIds: z.array(z.coerce.number()).optional(),
    categoryIdentifier: z.string(),
    itemsShown: z.array(z.string()).optional(),
    cacheBuster: z.coerce.number().optional(),
});

export const ownerReportsContract = c.router(
    {
        getCashFlowReport: {
            method: "GET",
            path: "/cash-flow",
            query: getCashFlowReportQuery,
            responses: {
                200: c.type<CashFlowReportDto>(),
            },
        },
        exportCashFlowReport: {
            method: "GET",
            path: "/cash-flow/export",
            query: getCashFlowReportQuery,
            responses: {
                200: c.type<StreamableFile>(),
                404: ErrorMessageSchema,
            },
        },
        getTopTransactions: {
            method: "GET",
            path: "/cash-flow/top-transactions",
            query: getTopTransactionsQuery,
            responses: {
                200: c.type<ProfitLossTopTransactionsDto>(),
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/owner-reports",
    },
);
